"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("react/jsx-runtime");function t({children:n}){return e.jsx(e.Fragment,{children:n})}t.displayName="SkeletonReady";exports.SkeletonReady=t;
